import React, {useEffect, useState} from "react";
import Filter from './Filter'
import Slider from '@material-ui/core/Slider';
import conversionTable from "../../api/unitConversion.json";
import {findUnit} from "../../utils";

const FilterRange = ({name, onValueChange, marks, unit, label, isOpen, currentValue}) => {
  const formattedMarks = marks.map(mark => ({value: parseFloat(mark.value)}));

  let currentMin;
  let currentMax;

  const parsedUnit = findUnit(marks) || unit;
  let factor = conversionTable[parsedUnit];
  if(factor === undefined){
    console.log(`Unit: ${unit} is missing in conversion table. Assuming factor 1.`);
    factor = 1;
  }


  const min = parseFloat(marks[0].value);
  const max = parseFloat(marks[marks.length - 1].value);

  if (currentValue) {
    currentMin = parseFloat(currentValue[0]);
    currentMax = parseFloat(currentValue[1]);
  } else {
    currentMin = min;
    currentMax = max;
  }
  const [value, setValue] = useState([currentMin ? currentMin : '', currentMax ? currentMax : '']);
  let propUpdate = false;
  useEffect(() => {
    setValue([currentMin, currentMax]);
    propUpdate = true;
  }, [currentValue]);

  const handleSliderChange = (_event, newValue) => {
    setValue(newValue);
  };

  const handleSliderChangeOnMouseUp = (_event, newValue) => {
    onValueChange(name, newValue.map(val => `${val} ${parsedUnit}`)  );
  }

  const handleMinInputChange = (_event) => {
      setValue([_event.target.value, value[1]]);

  }

  const handleMaxInputChange = (_event) => {
    setValue([value[0] ,_event.target.value]);

  }

  const handleInputKeyUp = (_event) => {
    if (_event.key === 'Enter') {
      onValueChange(name, value.map(val => `${val} ${parsedUnit}`));
    }
  }


  return (
    <Filter label={label} isOpen={isOpen}>
      <div className="product-finder-aside__fieldset">
        <div className="product-finder-aside__spread">
          <div className="product-finder-aside__cell" data-unit={unit}>
            <input
              value={value[0]}
              type="number"
              className="product-finder-aside__textbox"
              onChange={handleMinInputChange} onKeyUp={handleInputKeyUp}
            />
          </div>
          <div className="product-finder-aside__cell" data-unit={unit}>
            <input
              value={value[1]}
              type="number"
              className="product-finder-aside__textbox"
              onChange={handleMaxInputChange} onKeyUp={handleInputKeyUp}
            />
          </div>
        </div>

        <Slider
          className="range-slider range-slider--primary"
          key={`slider-${[min, max]}`}
          defaultValue={[currentMin, currentMax]}
          value={propUpdate ? [currentMin, currentMax] : value}
          aria-labelledby="range-slider"
          valueLabelDisplay="off"
          step={null}
          min={min}
          max={max}
          marks={formattedMarks}
          onChange={handleSliderChange}
          onChangeCommitted={handleSliderChangeOnMouseUp}
        />
        <div className="range-slider-labels">
          <span className="range-slider-labels__label" data-unit={unit}>{min}</span>
          <span className="range-slider-labels__label" data-unit={unit}>{max}</span>
        </div>
      </div>
    </Filter>
  );
};

export default FilterRange;
